import classes from './Backdrop.module.css'

// black backdrop for modal
const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.onClose} />;
};

export default Backdrop;
